<template>
  <div :class="$style.history_menu">
    <div :class="$style.description">（1990年から2024年まで）</div>
    <calendar :month="1" @child_event="handleClick" @child_scroll="scroll" :items="mlist" ></calendar>
    <div id="trace" :class="$style.trace_c"></div>
    <div :class="$style.list">
      <div :class="$style.date">{{ current.month }}月{{ current.date }}日</div>
      <div :class="$style.items">
        <div :class="$style.item" v-for="item in getHistoryData" :key="item.id">
          <div :class="$style.year">{{ item.year }} </div>
          <div :class="$style.detail">{{ item.message }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import Calendar from "@/components/molecules/Calendar.vue";
// import { mlist } from "@/assets/json/history/history_ob.js";
import { History } from "@/api"

export default Vue.extend({
  name: "HistoryMenu",
  components: {
    Calendar
  },
  data() {
    return {
      current: Object,
      mlist: [],
      history_items: [],
    };
  },
  mounted(){
    this.getHistoryList()
  },
  computed: {
    getHistoryData() {
      // const m = this.current["month"] - 1;
      // const d = this.current["date"];
      const m = this.current["month"];
      const d = this.current["date"]
      if (d == null) {
        return;
      }
      // return this.mlist[m][d];
      return this.mlist.filter(item=>item.month==m&&item.date==d);
    }
  },
  methods: {
    handleClick(current) {
      this.current = current;
    },
    scroll() {
      if (window.innerWidth <= 1023) this.$scrollTo("#trace");
    },
    getHistoryList() {
      History.getNumberOfItems().then(({count}) => {
        this.getList(count)
      })
    },
    getList(count) {
      History.getAllList(count).then(({results}) =>{
        this.mlist = results

      });
    },

  }
});
</script>

<style lang="scss" module>
@media only screen and (max-width: 1023px) {
  .history_menu {
    width: 100%;
    background: #fff;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    flex-direction: column;
    padding: 20px 0;
    margin-top: 20px;

    .trace_c {
      padding-top: 80px;
    }
    .list {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      flex-direction: column;
      width: 100%;
      margin: 0px 0;
      padding: 0 18px;
      .date {
        font-size: 26px;
        width: 100%;
        text-align: center;
      }
      .items {
        height: 450px;
        margin: 10px 0;
        overflow: scroll;
        .item {
          margin: 15px 0;
          
          .year {
            height: 30px;
            text-align: center;
            border-bottom: solid 2px #707070;
            font-size: 19px;
          }
          .detail {
            margin: 4px 10px;
            background-color: lavender;
          }
        }
      }
    }
  }
}

@media only screen and (min-width: 1024px) {
  .history_menu {
    width: 100%;
    height: 700px;
    background: #fff;
    display: flex;
    justify-content: center;
    margin-top: 40px;

    .description {
      position: absolute;
      margin: 40px 0px;
    }
    .list {
      width: 500px;
      height: 100%;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      flex-direction: column;
      .date {
        font-size: 26px;
        width: 100%;
        text-align: center;
      }
      .items {
        height: 400px;
        margin: 10px 0;
        overflow: scroll;
        .item {
          margin: 15px 0;
          .year {
            height: 30px;
            border-bottom: solid 2px #707070;
          }
          .detail {
            margin: 4px 10px;
            background-color: lavender;
          }
        }
      }
    }
  }
}
</style>
